import { Driver } from './driver';
import { Vehicle } from './vehicle';
import { isObject } from 'util';

export class Card {
  id?: number;
  card_no?: string;
  card_type?: string;
  status?: number; // enum {0: active, 1: inactive}
  limit?: number;
  expiration_date: string;
  pin_code?: string;
  limit_id?: number; // 0-100
  limit_name?: string;
  driver?: Driver;
  vehicle?: Vehicle;
  editable: boolean;
  driver_req: boolean;
  car_no_req: boolean;

  constructor(opts?: Card) {
    Object.assign(this as Object, opts || {});

    if (isObject(opts && opts.vehicle)) {
      this.vehicle = new Vehicle(opts.vehicle);
    }
    if (isObject(opts && opts.driver)) {
      this.driver = new Driver(opts.driver);
    }
  }

  get active() {
    return this.status !== 1;
  }

  set active(active) {
    this.status = active ? 0 : 1;
  }

  set isEditable(editable) {
    this.editable = editable;
  }

  get isEditable() {
    return this.editable;
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/model/card.ts